import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';

interface ConnectionInfoSectionLocalProps {
    connectionData?: {
        host: string;
        username: string;
        sshKey: string;
        directoryPath: string;
    } | null;
    subPath: string;
    fileName: string;
}

type ConnectionInfoSectionProps = ConnectionInfoSectionLocalProps & ToxnotComponentProperties;

class ConnectionInfoSectionComponent extends ToxnotComponent<ConnectionInfoSectionProps> {
    public render() {
        const { connectionData, subPath, fileName } = this.props;

        return (
            <>
                <p><strong>{this.localizeString("Host")}:</strong> {connectionData?.host || 'Not available'}</p>
                <p><strong>{this.localizeString("Username")}:</strong> {connectionData?.username || 'Not available'}</p>
                <p><strong>{this.localizeString("Remote Directory")}:</strong> {connectionData?.directoryPath || 'Not available'}</p>
                <p><strong>{this.localizeString("Sub Path")}:</strong> {subPath}</p>
                <p><strong>{this.localizeString("File Name")}:</strong> {fileName}</p>
            </>
        );
    }
}

export const ConnectionInfoSection = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(ConnectionInfoSectionComponent);
